import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MockProductImage from '@/components/brand/MockProductImage';
import { HomeMarquee, HomeSectionTitle, useMarqueeItems } from './HomeBlocks';

function dealLabel(d) {
  const v = d.discount_value;
  if (!v) return '';
  if (d.deal_type === 'percentage') return `−${v}%`;
  return `−₦${Number(v).toLocaleString()}`;
}

/**
 * "Latest Deals" strip, the same on every role's home. A tap opens the
 * deal on the Deals screen.
 */
export default function HomeLatestDeals({ deals }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { rows, isPadded, isStatic } = useMarqueeItems(deals);

  return (
    <>
      <HomeSectionTitle>{t('farmerHome.latestDeals')}</HomeSectionTitle>
      {deals.length > 0 ? (
        <HomeMarquee seconds={55} dataTestId="home-latest-deals" isStatic={isStatic}>
          {rows.map((d, i) => {
            const label = dealLabel(d);
            return (
              <button
                key={`${d.id}-${i}`}
                type="button"
                onClick={() => navigate(`/deals?deal=${encodeURIComponent(d.id)}`)}
                className="flex-shrink-0 w-56 h-32 rounded-2xl bg-gradient-to-br from-farm-forest to-farm-primary text-white p-3.5 relative focus:outline-none focus:ring-2 focus:ring-farm-gold-light overflow-hidden flex items-stretch gap-3"
                aria-hidden={isPadded(i) ? true : undefined}
                tabIndex={isPadded(i) ? -1 : 0}
              >
                <div className="flex flex-col justify-between text-left flex-1 min-w-0">
                  <div>
                    <p className="font-heading font-bold text-sm leading-tight line-clamp-2">{d.title}</p>
                    <p className="text-[11px] text-white/75 mt-0.5 line-clamp-2">{d.description}</p>
                  </div>
                  <p className="text-[11px] font-semibold text-farm-gold-light uppercase tracking-wide">
                    {t('farmerHome.shopDeal', { defaultValue: 'Shop deal' })} →
                  </p>
                </div>
                <div className="w-14 flex-shrink-0 rounded-lg overflow-hidden">
                  <MockProductImage variantKey={d.id || d.title || i} />
                </div>
                {label && (
                  <span className="absolute top-3 right-3 bg-farm-gold text-white text-xs font-bold px-2 py-0.5 rounded">
                    {label}
                  </span>
                )}
              </button>
            );
          })}
        </HomeMarquee>
      ) : (
        <p className="text-sm text-farm-forest/60 mb-5" data-testid="home-latest-deals-empty">
          {t('farmerHome.latestDealsEmpty', { defaultValue: 'No active deals right now.' })}
        </p>
      )}
    </>
  );
}
